export const routes = {
  HOME: '/',
  ATTR: '/attributes',
  MINT: '/mint',
  PIGGYCELL: '/attributes/piggycell',
};
